import Cookies from 'js-cookie';

class Team {
	constructor(){
		this.defaultCountry = 'ES';

		this.team_template =		'<div class="col-tb-8 col-sm-4">';
			this.team_template +=		'<div class="card">'
			this.team_template +=			'<div class="card__product">';
			this.team_template +=				'<a href="##URL##" title="##VIEW##" class="card">';
			this.team_template +=					'<div class="">';
			this.team_template +=						'<div class="card__profile_img">';
			this.team_template += 						'<span style="background: url(##IMGURL##); ';
			this.team_template +=								'background-position: center; ';
			this.team_template +=								'background-size: cover; ';
			this.team_template +=								'background-repeat: no-repeat; ';
			this.team_template +=								'display: inline-block;"></span>';
			this.team_template +=						'</div>';
			this.team_template +=						'<div class="card__desc">';
			this.team_template +=							'<content-title class="mobile-title">';
			this.team_template += 							'<h4>##TITLE##</h4>';
			this.team_template +=							'</content-title>';
			this.team_template += 							'<section>';
			this.team_template += 								'<p>##POSITION##</p>';
			//this.team_template += 								'<div class="links">##VIEW##</div>';
			this.team_template += 							'</section>';
			this.team_template +=						'</div>';
			this.team_template +=					'</div>';
			this.team_template +=				'</a>';
			this.team_template +=			'</div>';
			this.team_template +=		'</div>';
			this.team_template +=	'</div>';

		this.events_set = false;
		this.getTeamInfo();
	}

	getTeamInfo( country = null ){
		//The menu sets value to global and I need null
		if( country == 'global' ) {
			country = null;
		}
		var team_section = document.querySelector("div.team__list");
		if( null != team_section && "undefined" != typeof window.team_data ){
			//var current_country = (null == country)?'All':country;
      var current_country = (null == country) ? Cookies.get('selectedCountry') : country;
			//var current_country;
			if( undefined == Cookies.get('selectedCountry') ) {
				current_country = this.defaultCountry;
        Cookies.set('selectedCountry', current_country);
			}
			var body_classes = document.querySelector("body").getAttribute("class");
			//I don't want this to run if visiting from single geography content
			if( body_classes.indexOf("geography-pt") >= 0 || body_classes.indexOf("single-team-member") >= 0 ){
				return false;
			}

			var arr_classes = body_classes.split(" ");
			var post_id = -1;
			var team_template = this.team_template;
			var team_str = '';

			for( var i = 0; i < arr_classes.length; i++) {
				if( arr_classes[i].indexOf("postid-") >= 0 ){
					post_id = arr_classes[i].split("-")[1];
				}
			}

			if( current_country != 'All' ) {
				for( var key in window.team_data[current_country] ) {
					let item = window.team_data[current_country][key];
					if( post_id > 0 && item.post_id == post_id ){
						continue;
					}
					team_str += team_template
						.replace("##IMGURL##", item.imgurl)
						.replace(/##TITLE##/g, item.title)
						.replace("##POSITION##", item.position)
						.replace(/##VIEW##/g, '')
						.replace("##URL##", '#');
				}
			} else {
				let all_teams = [];
				for( var key1 in window.team_data ) {
					//console.log( 'element', typeof window.team_data[key1], window.team_data[key1].length, window.team_data[key1] );
					if( 'object' == typeof window.team_data[key1] ) {
						for( var key2 in window.team_data[key1] ) {
							let item = window.team_data[key1][key2];
							//console.log(item);
							all_teams.push(item);
						}
					}
				}

				//console.log(all_teams)
				//all_teams.sort((a,b) => (a.title > b.title) ? 1 : ((b.title > a.title) ? -1 : 0));
				all_teams.sort((a,b) => a.title.localeCompare(b.title) );
				all_teams.forEach(team_member => {
					let print = true;
					if( post_id > 0 && team_member.post_id == post_id ){
						print = false;
					}

					if( print ) {
						team_str += team_template
							.replace("##IMGURL##", team_member.imgurl)
							.replace(/##TITLE##/g, team_member.title)
							.replace("##POSITION##", team_member.position)
							.replace(/##VIEW##/g, '')
							.replace("##URL##", '#');
					}
				})
			}
			team_section.innerHTML = team_str;

			if( !this.events_set ) {
				this.loadEvents();
			}

			/** Prevent default on empty links */
			document.querySelectorAll('.card__product a').forEach( link => {
				link.addEventListener('click', e => {
					e.preventDefault();
				});
			});
		}
	}

	loadEvents() {
		var _self = this;
		//Add event listener to geo menu items
		var geo_links = document.querySelectorAll("div.teams-submenu li.no-click a");
		for( var i = 0; i < geo_links.length; i++ ){
			geo_links[i].addEventListener('click', function(){
				_self.getTeamInfo( this.getAttribute('data-iso') );
			});
		}
		this.events_set = true;
	}
}

export default Team
